import type { Prisma } from "@blis/prisma";

export type DonorIds = {
  caseId: string;
  unosId: string | null;
  donorIds: string[];
};

type SubjectWithIds = {
  caseId: string;
  ids: {
    type: string;
    value: string;
  }[];
};

type AccessionBackup = {
  caseId: string;
  unosId: string | null;
  donorIds: Prisma.JsonValue | null;
};

export function getDonorIds(subject: SubjectWithIds): DonorIds {
  const caseId = subject.ids.find((id) => id.type === "caseId")?.value;
  const unosId = subject.ids.find((id) => id.type === "unosId")?.value;
  const donorIds = subject.ids
    .filter((id) => id.type === "other")
    .map((id) => id.value);

  return {
    caseId: caseId || subject.caseId,
    unosId: unosId || null,
    donorIds: donorIds || [],
  };
}

export const subjectIdTypeMap = {
  caseId: "Donor ID",
  unosId: "UNOS ID",
  other: "Alternate ID",
};
